import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import TradesPage from './pages/TradesPage';
import SettingsPage from './pages/SettingsPage';
import BrokerManagementPage from './pages/BrokerManagementPage';
import AutomationSettingsPage from './pages/AutomationSettingsPage';
import AnalyticsPage from './pages/AnalyticsPage';
import Layout from './components/Layout';
import { setCredentials } from './features/auth/authSlice';
import apiClient from './api/apiClient';

function App() {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    const user = JSON.parse(localStorage.getItem('user'));
    if (token && user) {
      apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      dispatch(setCredentials({ user, token }));
    }
  }, [dispatch]);

  return (
    <Router>
        <Routes>
          <Route path="/login" element={<AuthPage />} />

          {/* Protected Routes Wrapped in Layout */}
          <Route path="/dashboard" element={isAuthenticated ? <Layout><DashboardPage /></Layout> : <Navigate to="/login" />} />
          <Route path="/trades" element={isAuthenticated ? <Layout><TradesPage /></Layout> : <Navigate to="/login" />} />
          <Route path="/brokers" element={isAuthenticated ? <Layout><BrokerManagementPage /></Layout> : <Navigate to="/login" />} />
          <Route path="/settings" element={isAuthenticated ? <Layout><SettingsPage /></Layout> : <Navigate to="/login" />} />
          <Route path="/settings/automation" element={isAuthenticated ? <Layout><AutomationSettingsPage /></Layout> : <Navigate to="/login" />} />
           <Route path="/analytics" element={isAuthenticated ? <Layout><AnalyticsPage /></Layout> : <Navigate to="/login" />} />
          <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
    </Router>
  );
}

export default App;
